import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import useFetch from "../../hooks/useFetch";
import { Home_banner_url } from "../../api/urls";

export default function HomeHeroSlider() {
  const { data: homeBannerData, loading } = useFetch(Home_banner_url);
  const data = homeBannerData?.data || [];
  // console.log(loading, "loadingooo");
  const [current, setCurrent] = useState(0);

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? data.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrent((prev) => (prev === data.length - 1 ? 0 : prev + 1));
  };

  useEffect(() => {
    if (!data?.length) return;

    const interval = setInterval(() => {
      setCurrent((prev) => (prev === data.length - 1 ? 0 : prev + 1));
    }, 5000);

    return () => clearInterval(interval);
  }, [data.length]);

  return (
    <div
      className={`relative w-full overflow-hidden rounded-2xl mt-10 ${loading || data?.length > 0 ? "mb-14" : ""}`}
    >
      {/* Slides */}
      <div
        className="flex transition-transform duration-700 ease-in-out"
        style={{ transform: `translateX(-${current * 100}%)` }}
      >
        {loading ? (
          <div className="min-w-full md:h-[80vh] h-[40vh] relative flex items-center justify-center bg-gray-300 animate-pulse rounded-md" />
        ) : (
          data?.map((item) => (
            <div
              key={item.id}
              className="min-w-full md:h-[80vh] h-[40vh] relative flex items-center justify-center bg-gray-100"
            >
              <img
                src={item.ad_image}
                alt={item.printable_name}
                className="absolute inset-0 w-full h-full object-cover"
              />

              {/* Overlay */}
              <div className="relative z-10 bg-white/80 px-10 py-4">
                <h2 className="md:text-5xl text-lg font-serif tracking-widest text-black">
                  NEW COLLECTION
                </h2>
              </div>

              {/* Dark overlay */}
              <div className="absolute inset-0 bg-black/30" />
            </div>
          ))
        )}
      </div>

      {/* Left Arrow */}
      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full shadow md:block hidden"
      >
        <ChevronLeft size={22} />
      </button>

      {/* Right Arrow */}
      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full shadow md:block hidden"
      >
        <ChevronRight size={22} />
      </button>

      {/* Dots */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
        {data.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`h-2 w-2 rounded-full transition ${
              current === index ? "bg-white w-5" : "bg-gray-400"
            }`}
          />
        ))}
      </div>
    </div>
  );
}
